import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';

import Icon, { IconName } from '../icon/Icon';

import './IconList.scss';

export interface IconListProps
  extends ComponentPropsWithoutRef<ElementType<any>> {
  className?: string;
}

const IconList = ({ className, ...props }: IconListProps) => {
  return <ul className={classnames('icon-list__list', className)} {...props} />;
};

export interface IconListItemProps
  extends ComponentPropsWithoutRef<ElementType<any>> {
  component?;
  icon: IconName | null;
  className?: string;
  children;
}

const IconListItem = ({
  component: Component = 'button',
  icon,
  className,
  children,
  ...props
}: IconListItemProps) => {
  const iconNode = typeof icon === 'string' ? <Icon name={icon} /> : icon;
  return (
    <li className="icon-list__list-item">
      <Component
        className={classnames('icon-list__list-item-button', className)}
        {...props}
      >
        {Boolean(iconNode) && (
          <span className="icon-list__list-item-icon">{iconNode}</span>
        )}
        <span className="icon-list__list-item-label">{children}</span>
      </Component>
    </li>
  );
};

export default IconList;
export { IconList, IconListItem };
